import React, { useEffect, useRef, useState } from "react"
import { Col, Container, Row } from "react-bootstrap"
import { useParams, useNavigate } from "react-router-dom"
import { CSSTransition } from "react-transition-group"
import { isLoggedIn } from "../../api/AuthService"
import HeaderComponent from "../commonComponents/HeaderComponent"
import UnreleasedSearchResultDisp from "../search/UnreleasedSearchResultDisp"

const normalizeUnreleasedPartName = (rawPartName) => {
   if (!rawPartName) return ""

   let decoded = rawPartName
   try {
      decoded = decodeURIComponent(rawPartName)
   } catch (error) {
      decoded = rawPartName
   }

   // Keep only the current object id in case a stale value is accidentally chained.
   const cleaned = decoded.replace(/\\+$/g, "")
   const segments = cleaned.split("/").filter(Boolean)
   return segments.length > 0 ? segments[segments.length - 1] : cleaned
}

function UnreleasedSearchPage() {
   const { partName } = useParams()
   const navigate = useNavigate()
   const nodeRef = useRef(null)
   const [inProp] = useState(true)
   const [authorized, setAuthorized] = useState(false)
   const normalizedPartName = normalizeUnreleasedPartName(partName)

   useEffect(() => {
      // Each unreleased deep link should start a fresh trail.
      sessionStorage.removeItem("breadCrumb")

      if (!isLoggedIn("unreleasedSearch", normalizedPartName)) {
         navigate("/", { replace: true })
      } else {
         setAuthorized(true)
      }
   }, [normalizedPartName, navigate])

   if (!authorized) return null

   return (
      <React.Fragment>
         <HeaderComponent pdfDataSet={{}} />
         <CSSTransition timeout={300} in={inProp} classNames="my-node" nodeRef={nodeRef}>
            <Container fluid ref={nodeRef}>
               <Row>
                  <Col md="12">
                     <UnreleasedSearchResultDisp partName={normalizedPartName} />
                  </Col>
               </Row>
            </Container>
         </CSSTransition>
      </React.Fragment>
   )
}

export default UnreleasedSearchPage
